var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wholeContext"},[_c('app-sidebar'),_c('app-header',{attrs:{"transDataSet":_vm.transDate}}),_c('div',{staticClass:"appContext"},[_c('tracking-progress',{attrs:{"transDataSet":_vm.transDate}}),_c('password-find-material',{on:{"firstCall":_vm.firstReceive,"secondCall":_vm.secondReceive}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }